export enum DataFieldType {
    Text = 1,
    Numeric = 2,
    Calendar = 3,
    PreSetOptions = 4,
}
